import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConstants } from '@utils/app.constants';
import { ListResource } from '@resources/list.resource';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMUrlUtilService } from './lm-url-util.service';
import { FormRequestType } from '@utils/app.constants';
import * as _ from 'lodash';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LMFormRequest } from '@app/components';


@Injectable()
export class LMFieldUtilService {

  constructor(
    private http: HttpClient,
    private lmLoggerService: LMLoggerService,
    private lmUrlUtilService: LMUrlUtilService,
  ) {}

  /*
   * Sorts a JSONArray filled with JSONObjects.
   */
  public sort(array: Array<LMDataView>, comparatorFld: string, displayFields: Array<LMListDisplayField>) {
    let comparatorFldPresent = false;
    for (let i = 0; i < displayFields.length; i++) {
      if (displayFields[ i ].fieldId === comparatorFld) {
        comparatorFldPresent = true;
        break;
      }
    }

    if (!comparatorFldPresent) {
      return;
    }

    array.sort(sortByProperty(comparatorFld));

    function sortByProperty(property) {
      'use strict';
      return function(a, b) {
        return a.fields[ property ].value - b.fields[ property ].value;
      };
    }
  }

  public typeAllowsMultipleSearchTerms(type: string): boolean {
    return type === AppConstants.BCD
      || type === AppConstants.PERCENT
      || type === AppConstants.NUMERIC
      || type === AppConstants.ALPHALOWER
      || type === AppConstants.ALPHAUPPER
      || type === AppConstants.ALPHARIGHT;
  }

  public isBlank(type: string, value: any): boolean {
    if (type) {
      type = type.toUpperCase();
    }

    // TODO: Should be simplied to first handle the types that allow a zero value and then everything else

    if (type === AppConstants.ALPHA
      || type === AppConstants.ALPHALOWER
      || type === AppConstants.ALPHARIGHT
      || type === AppConstants.ALPHAUPPER
      || type === AppConstants.BINARYDOCUMENT
      || type === AppConstants.BCD
      || type === AppConstants.MMDD
      || type === AppConstants.NUMERIC
      || type === AppConstants.PERCENT
      || type === AppConstants.TEXT
      || type === AppConstants.TIME
      || type === AppConstants.TIMESTAMP
      || type === AppConstants.YYYY
      || type === AppConstants.YYYYMM
      || type === AppConstants.YYYYMMDD) {

      // alpha types don't check for zero
      const isAlpha = (type === AppConstants.ALPHA
      || type === AppConstants.ALPHALOWER
      || type === AppConstants.ALPHARIGHT
      || type === AppConstants.ALPHAUPPER
      || type === AppConstants.BINARYDOCUMENT
      || type === AppConstants.TEXT);

      // if blank or zero, then return true
      if (value === undefined
        || value === null
        || _.trim(value) === ''
        || (!isAlpha && !isNaN(parseFloat(value)) && parseFloat(value) === 0)) {
        return true;
      }
    } else if (type === AppConstants.BOOLEAN
    || type === AppConstants.UNIQUEID) {
      if (value === undefined
        || value === null
        || _.trim(value) === '') {
        return true;
      }
    }

    return false;
  };

  public toBlankValue = function(type?: string): any {
    if (type === AppConstants.YYYYMMDD
        || type === AppConstants.YYYYMM
        || type === AppConstants.MMDD
        || type === AppConstants.YYYY
        || type === AppConstants.TIME
        || type === AppConstants.TIMESTAMP
        || type === AppConstants.NUMERIC
        || type === AppConstants.BCD
        || type === AppConstants.PERCENT) {
      return 0;
    }
    return '';
  };

  /**
   * params
   * {
   * 		fieldId - the encoded field id of the field that is initiating the initial value request.
   * 		dataView - the dataview for the record where the initial value is to be executed against.
   * }
   */
  public getUserDefinedStates(args: any) {
    this.formRequest(Object.assign({}, args, { requestType: 'userDefinedStates' }));
  }

  //    public getFieldHistory(args)
  //    {
  //        this.formRequest(Object.assign({}, args, { requestType: "fieldHistory"}));
  //    }
  //
  //    public getFieldPendingChanges(args)
  //    {
  //        this.formRequest(Object.assign({}, args, { requestType: "fieldPendingChanges"}));
  //    }
  //
  //    public getBusClassNames(args)
  //    {
  //        this.formRequest(Object.assign({}, args, { requestType: "busClassNames"}));
  //    }
  //
  //    public getListNamesForBusClass(args)
  //    {
  //        this.formRequest(Object.assign({}, args, { requestType: "listNamesForBusClass"}));
  //    }
  //
  //    public getListNamesAndViewsForBusClass(args)
  //    {
  //        this.formRequest(Object.assign({}, args, { requestType: "listNamesAndViewsForBusClass"}));
  //    }
  //
  //    public getConditionNamesForBusClass(args)
  //    {
  //        this.formRequest(Object.assign({}, args, { requestType: "conditionNamesForBusClass"}));
  //    }
  //
  //    public validateCondition(args)
  //    {
  //        this.formRequest(Object.assign({}, args, { requestType: "validateCondition"}));
  //    }
  //
  //    public validateField(args)
  //    {
  //        this.formRequest(Object.assign({}, args, { requestType: "validateField"}));
  //    }
  //
  //    public drillPoints(args)
  //    {
  //        this.formRequest(Object.assign({}, args, { requestType: "drillPoints"}));
  //    }
  //
  //    public schedulePdf(args)
  //    {
  //        this.formRequest(Object.assign({}, args, { requestType: "schedulePdf"}));
  //    }
  //
  //    public createReport(args)
  //    {
  //        this.formRequest(Object.assign({}, args, { requestType: "createReport"}));
  //    }
  //
  //    public saveListPersonalization(args)
  //    {
  //        this.formRequest(Object.assign({}, args, { requestType: "saveListPersonalization"}));
  //    }
  //
  //    public deleteListPersonalization(args)
  //    {
  //        this.formRequest(Object.assign({}, args, { requestType: "deleteListPersonalization"}));
  //    }

  public formRequest(args: any) {
    this.makeFormRequest(args)
      .subscribe(
        (result: any) => {
          let status: string = AppConstants.STATUS_COMPLETED;

          if (result.status === AppConstants.VIEW_EXCEPTION
          || result.status === AppConstants.STATUS_SYSTEM_ERROR) {
            status = result.status;
          }

          if (args.callback && typeof args.callback === 'function') {
            args.callback(status, result);
          }
        },
        error => {
          if (args.callback && typeof args.callback === 'function') {
            args.callback(AppConstants.STATUS_SYSTEM_ERROR, error);
          }
        }
      );
  }

  public decodeFieldName(fieldName: string): string {
    fieldName = fieldName.replace(new RegExp('_op_', 'g'), '(');
    fieldName = fieldName.replace(new RegExp('_cp_', 'g'), ')');

    fieldName = fieldName.replace(new RegExp('_ob_', 'g'), '{');
    fieldName = fieldName.replace(new RegExp('_co_', 'g'), '}');

    fieldName = fieldName.replace(new RegExp('_ohb_', 'g'), '[');
    fieldName = fieldName.replace(new RegExp('_chb_', 'g'), ']');

    fieldName = fieldName.replace(new RegExp('_lab_', 'g'), '<');
    fieldName = fieldName.replace(new RegExp('_rab_', 'g'), '>');

    fieldName = fieldName.replace(new RegExp('_add_', 'g'), '+');
    fieldName = fieldName.replace(new RegExp('_div_', 'g'), '/');
    fieldName = fieldName.replace(new RegExp('_hat_', 'g'), '^');
    fieldName = fieldName.replace(new RegExp('_pct_', 'g'), '%');
    fieldName = fieldName.replace(new RegExp('_spc_', 'g'), ' ');
    fieldName = fieldName.replace(new RegExp('_col_', 'g'), ':');
    fieldName = fieldName.replace(new RegExp('_prd_', 'g'), '.');
    fieldName = fieldName.replace(new RegExp('_apo_', 'g'), '\'');
    fieldName = fieldName.replace(new RegExp('_sc_', 'g'), '');
    fieldName = fieldName.replace(new RegExp('_quot_', 'g'), '"');

    return fieldName;
  }
  /**
   *		requestType    : (string)
   *		fieldId        : (string)
   *		dataView       : (object)
   *		action         : (string)
   *		param1         : (string)
   *		param2         : (string)
   *		param3         : (string)
   *
   *      For pdf schedule only
   *
   *		orientation    : (string)
   *		printOption    : (string)
   *		search         : (string)
   *		selectedRows   : (string)
   *		maxLevels      : (string)
   *		scheduleView   : (object)
   *	}
   */
  private makeFormRequest(args: any): Observable<Response> {
    const resource = args.resource;
    const reportDataView = args.reportDataView;
    const userFolderId = args.userFolderId;
    let url: string;
    let scheduleView: any;

    if (!args.resource) {
      throw 'The resource argument must be either a ListResource or FormResource.';
    }

    if (args.requestType === FormRequestType.SchedulePdf) {
      const fromResource: any = args.fromResource;
      const dataViewSet: any = args.dataViewSet; // todo set type
      const orientation: any = args.orientation;
      const displaySearchCriteria: any = args.search;
      const printOption: any = args.printOption;
      scheduleView = args.scheduleView;
      const selectedRows: any = args.selectedRows;
      const maxLevels: number = args.maxLevels;

      const params: any = {
        output:        'pdf',
        orientation,
        printOption,
        searchForm:    displaySearchCriteria,
        filter:        undefined,
        sortOrderName: undefined,
        isAscending:   undefined
      };

      if (maxLevels !== undefined) {
        params[ maxLevels ] = maxLevels;
      }

      if (dataViewSet !== undefined) {
        if (dataViewSet.filter) {
          params.filter = dataViewSet.filter;
        }

        if (dataViewSet.sortOrderName) {
          params.sortOrderName = dataViewSet.sortOrderName;
        }

        if (dataViewSet.isAscending) {
          params.isAscending = dataViewSet.isAscending;
        }
      }

      if (fromResource) {
        params[ fromResource.resourceType ] = fromResource.resourceId;
      }

      if (printOption === AppConstants.PDF_SELECTED_WITH_DETAILS_ACTION && selectedRows.length > 0) {
        const newListResource = new ListResource(
          {
            resourceId: dataViewSet.data[ selectedRows[ 0 ] ].resourceId,
            listName:   resource.listName
          });
        url = this.lmUrlUtilService.buildUrl({ resource: newListResource, params });
      } else {
        url = this.lmUrlUtilService.buildUrl({ resource, params });
      }
    } else if (args.requestType === 'createReport') {
      const fromResource = args.fromResource;
      const dataViewSet = args.dataViewSet;

      const params: any = {
        filter:        undefined,
        sortOrderName: undefined,
        isAscending:   undefined
      };

      if (dataViewSet !== undefined) {
        if (dataViewSet.filter) {
          params.filter = dataViewSet.filter;
        }

        if (dataViewSet.sortOrderName) {
          params.sortOrderName = dataViewSet.sortOrderName;
        }

        if (dataViewSet.isAscending) {
          params.isAscending = dataViewSet.isAscending;
        }
      }

      if (fromResource) {
        params[ fromResource.resourceType ] = fromResource.resourceId;
      }

      url = this.lmUrlUtilService.buildUrl({ resource, params });
    } else {
      if (userFolderId) {
        url = this.lmUrlUtilService.buildUrl({ resource, userFolderId });
      } else {
        url = this.lmUrlUtilService.buildUrl({ resource });
      }
    }

    const formRequest: LMFormRequest = {
      requestType:    args.requestType,
      fieldId:        args.fieldId,
      dataView:       args.dataView,
      action:         args.action,
      param1:         args.param1,
      param2:         args.param2,
      param3:         args.param3,
      drillName:      undefined,
      scheduleView:   undefined,
      reportDataView: undefined,
      viewReport:     undefined
    };

    if (args.selectListName) {
      formRequest.selectListName = args.selectListName;
      if (args.selectLink) {
        formRequest.selectLink = args.selectLink;
      }
    }

    if (args.drillName) {
      formRequest.drillName = args.drillName;
    }

    if (args.requestType === 'schedulePdf' && scheduleView !== undefined) {
      formRequest.scheduleView = scheduleView;
    }

    if (args.requestType === 'createReport') {
      formRequest.reportDataView = reportDataView;
      if (args.viewReport) {
        formRequest.viewReport = args.viewReport;
      }
    }

    const headers = new HttpHeaders();
    headers.append('Content-Type', 'application/json;charset=utf-8');

    // TODO: need to pass this on the http call
    //     let async = args.async === false ? false : true;

    return <Observable<Response>> this.http.post(url, JSON.stringify(formRequest), { headers })
      .pipe(catchError(error => this._handleError(error)));
  }

  private _handleError(error: Response) {
    // in a real world app, we may send the error to some remote logging infrastructure
    // instead of just logging it to the console
    this.lmLoggerService.log(error);
    return throwError(error || 'Server error');
  }
}
